import { buildRpaDomainSeoBundle } from "../rpaSeoUtils";

export const PUBLIC_SECTOR_DOMAIN_INTRO = {
  title: "Public Sector & Government",
  content: "Document AI + RPA and workflow automation across Licensing, Public Works. Each use case includes challenge and solution detail, process diagrams, and human-in-the-loop review for enterprises in India, UAE, KSA, UK, and USA.",
  seoDescription: "Public Sector & Government automation use cases — document AI + RPA and workflow automation across Licensing, Public Works. Validation, approvals, system updates, and exception handling.",
};

const slugify = (label) =>
  label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

function withMeta(uc) {
  return {
    ...uc,
    groupId: slugify(uc.subIndustry),
    seoTitle: uc.title,
    title: uc.shortTitle || uc.title,
    systems: uc.systems || SYSTEMS,
  };
}

const SYSTEMS = "Case Management, Document Management, CRM, Email, Portal, Power BI";

const RAW = [
  {
    id: "permit-and-license-document-validation",
    subIndustry: "Licensing",
    department: "Permits",
    businessProcess: "Permit and license document validation",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Permit and license document validation",
    title: "Permit And License Document Validation Automation for Public Sector & Government",
    seoKeywords: "public sector & government, permit and license document validation, AI automation, RPA, agentic AI, document AI",
    challenge: "Permit teams manually verify forms, IDs, certificates, payments and approvals.",
    solution: "Implement Document AI + RPA to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    automationType: "Document AI + RPA",
    buyerPersona: "Licensing Head, CIO",
    systems: "Permit System, DMS, Payment Gateway, GIS",
    agentsRequired: "Document Extraction Agent, Permit Validation Agent, Exception Agent",
    inputData: "Forms, PDFs, emails, scanned documents, attachments, master data and permit and license document validation rules",
    outputActions: "Extracted structured data, validation results, exception list and approval-ready permit and license document validation record",
    keyBenefits: "Faster Turnaround, Lower Manual Effort, Improved Accuracy And Better Operational Visibility",
    roiTimeline: "6-12 months",
    implementationComplexity: "High",
    businessImpact: "High",
  },
  {
    id: "public-works-invoice-verification",
    subIndustry: "Public Works",
    department: "Finance",
    businessProcess: "Public works invoice verification",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Public works invoice verification",
    title: "Public Works Invoice Verification Automation for Public Sector & Government",
    seoKeywords: "public sector & government, public works invoice verification, AI automation, RPA, agentic AI, document AI",
    challenge: "Contractor bills are manually matched with work orders, measurements and approvals.",
    solution: "Implement Document AI + RPA to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    automationType: "Document AI + RPA",
    buyerPersona: "Public Works Head, CFO",
    systems: "ERP, Project Management, DMS, Email",
    agentsRequired: "Document Extraction Agent, Public Validation Agent, Exception Agent",
    inputData: "Forms, PDFs, emails, scanned documents, attachments, master data and public works invoice verification rules",
    outputActions: "Extracted structured data, validation results, exception list and approval-ready public works invoice verification record",
    keyBenefits: "Faster Closure, Fewer Reconciliation Errors, Reduced Manual Effort And Better Finance Visibility",
    roiTimeline: "6-12 months",
    implementationComplexity: "High",
    businessImpact: "High",
  },
];
export const PUBLIC_SECTOR_USE_CASES = RAW.map(withMeta);
const GROUP_ORDER = ["Licensing", "Public Works"];
export const PUBLIC_SECTOR_GROUPS = GROUP_ORDER.map((label) => ({
  id: slugify(label),
  label,
})).filter((g) => PUBLIC_SECTOR_USE_CASES.some((uc) => uc.groupId === g.id));
const seo = buildRpaDomainSeoBundle({
  domainSlug: 'public-sector-government-domain',
  domainIntro: PUBLIC_SECTOR_DOMAIN_INTRO,
  useCases: PUBLIC_SECTOR_USE_CASES,
});
export const PUBLIC_SECTOR_USE_CASES_SEO = seo.useCasesSeo;
export const PUBLIC_SECTOR_DOMAIN_FAQS = seo.domainFaqs;
export const PUBLIC_SECTOR_ITEM_LIST_JSONLD = seo.itemListJsonLd;
export const PUBLIC_SECTOR_FAQ_JSONLD = seo.faqJsonLd;
export const PUBLIC_SECTOR_BREADCRUMB_JSONLD = seo.breadcrumbJsonLd;
export const PUBLIC_SECTOR_WEBPAGE_JSONLD = seo.webPageJsonLd;

